import React from "react";
import { Middleware } from "polymatic";

import { on, use } from "@piqnt/runtime-core/decorators";
import { SignalMiddleware } from "@piqnt/runtime-core/signals";

import { type SpaceContext } from "@piqnt/runtime-space/space";

import { UiProvider } from "@piqnt/runtime-core/react/Provider";
import { ReactMountMiddleware } from "@piqnt/runtime-core/react/ReactMount";

import { LiveOutlinePanel } from "@piqnt/runtime-testbed/world-outline";
import { PlainOutlinePanel } from "@piqnt/runtime-space/drawing-outline";

export class OutlinePlugin extends Middleware<SpaceContext> {
  @use()
  signal = new SignalMiddleware();

  @use()
  reactMount = new ReactMountMiddleware<SpaceContext>({
    container: "outline-panel",
    render: (context) => {
      if (!context.showOutline?.value) return null;
      return (
        <UiProvider>
          <LiveOutlinePanel />
          <PlainOutlinePanel />
        </UiProvider>
      );
    },
  });

  @on("activate")
  handleActivate = () => {
    this.signal.effect(() => {
      const containerElement = this.context.containerElement?.value;
      const showOutline = this.context.showOutline.value;
      if (containerElement) {
        containerElement.style.right = showOutline ? "290px" : "0px";
      }
      return () => {
        containerElement.style.right = "0px";
      };
    });
  };
}
